import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

export default function PopupDialog(props) {
  const { feature, onClose } = props;

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {feature.title || ""}
        <IconButton onClick={onClose} color="primary" sx={{ float: "right", marginRight: -1 }} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div dangerouslySetInnerHTML={{ __html: feature.content }} />
      </DialogContent>
    </Dialog>
  );
}
